import _ from "lodash";
import appendTypeAndCountry from "../../../utils/append-type-and-country";
import ExerciseLibrary from "./ExerciseLibrary";

import AddSecondaryMovementModal from "../../../parts/modals/add-secondary-movement";
import EditPrimaryMovement from "../../../parts/modals/edit-primary-movement";
import AddOtherExerciseModal from "../../../parts/modals/add-other-exercise";
import JWPlayerVideoModal from "../../../parts/modals/jwplayer-video";
import ConfirmStopTraining from "./components/ConfirmStopTraining";
import ConfirmRemoveAthlete from "./components/ConfirmRemoveAthlete";
import { whoIsAthleteCoach } from "../../../utils/user-helpers";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

export const getExerciseLibrary = async ({
  res,
  req,
  locals,
  momentTZ,
  load,
}) => {
  locals.athlete = appendTypeAndCountry(locals.athlete, momentTZ);

  const modal = _.get(req.query, "modal", {});
  const {
    athlete,
    activeUser,
    query,
    activeUserToRequest,
    organizationRoleName,
  } = locals;
  const user = athlete || activeUserToRequest;
  const isNew = !_.has(query, "modal.index");
  const primary = _.get(query, "modal.primary", "squat");
  const library = _.get(user, `exerciseLibrary.${primary}`) || [];
  const index = _.get(query, "modal.index", _.size(library));

  const intensityMeasure =
    _.get(activeUserToRequest, "intensityMeasure", "rpe") === "rpe"
      ? "RPE"
      : "RiR";
  const isRiR = intensityMeasure === "RiR";

  const isAllowToViewAllOrganizationsAthletes =
    organizationRoleName &&
    (organizationRoleName === "Owner" || organizationRoleName === "Admin");

  if (
    activeUser.organizationId &&
    isAllowToViewAllOrganizationsAthletes &&
    !locals.allAthletesFromOrganization
  ) {
    await load("allAthletesFromOrganization");
  }
  const organizationCoach = query.organizationCoach || undefined;
  const organizationCoachId = organizationCoach
    ? whoIsAthleteCoach(
        locals.activeUser.athletes,
        athlete,
        locals.activeUser._id,
        organizationCoach
      )
    : undefined;
  locals.modal = {
    "stop-training": <ConfirmStopTraining />,
    "remove-athlete": <ConfirmRemoveAthlete />,
    "add-secondary-movement": (
      <AddSecondaryMovementModal
        isNew={isNew}
        library={library}
        index={index}
        athlete={athlete}
        primary={primary}
        user={user}
      />
    ),
    "edit-primary-movement": (
      <EditPrimaryMovement
        query={locals.query}
        activeUserToRequest={locals.activeUserToRequest}
        athlete={locals.athlete}
      />
    ),
    "add-other-exercise": (
      <AddOtherExerciseModal
        isNew={isNew}
        library={library}
        index={index}
        athlete={athlete}
        intensityMeasure={intensityMeasure}
        isRiR={isRiR}
      />
    ),
    "exercise-set-video": <JWPlayerVideoModal mediaId={query.mediaId} />,
    "activity-feed": <ActivityDrawer />,
  }[modal.type];

  _.defaults(req.query, { primary: "assistant", type: "powerlifting" });
  res.body = (
    <ExerciseLibrary
      athlete={locals.athlete}
      locals={locals}
      organizationCoachId={organizationCoachId}
    />
  );
};
